﻿<template>
    <div class="ci-items" :hidden="!add_on">
        <button type="button" class="ci-chip is-button" :aria-expanded="isOpen_Item_List" @click="isOpen_Item_List = !isOpen_Item_List">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
            {{getTrip_Items()}}
            <svg class="ci-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
        </button>
        <div class="ci-popover" :hidden="!isOpen_Item_List">
            <p class="ci-popover-title">{{getTrip_Heading()}}</p>
            <ul>
                <li v-for="(passenger, index) in $store.getters.get_Booking.passengers" :key="index">
                    <label class="pp-check">
                        <input type="checkbox" :checked="Passenger_Selected(passenger)" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded" @change="Toggle_Passenger(index)" />
                        {{getTrip_Pricing(passenger)}}
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts" src="./basket_item.ts"></script>
